import { createAsyncThunk } from '@reduxjs/toolkit';
import * as API from '../api/index.js';
import { notification } from 'antd';
import { toggleModal } from '../reducers/generalReducer.js';
import { historyChangeStatus } from '../utils/constants.js';
import { selectPerPage } from '../selectors/general.js';

const handleError = (message) => {
    notification.error({
        message: 'Error',
        description: message || 'Server error',
    });
};

const mapBalanceUpdateCodeToDescription = (balanceHistory) => {
    return balanceHistory.map((entry) => ({
        ...entry,
        reasonForChange: historyChangeStatus[entry.reasonForChange],
    }));
};

export const fetchUserStatistics = createAsyncThunk(
    'userStatistics/fetch',
    async ({ page, query }, { rejectWithValue, getState }) => {
        try {
            const state = getState();
            const perPage = selectPerPage(state);
            const { maxPageNumber, statistics } = await API.user.getUserStatistics(page, perPage, query);

            if (!page) {
                return { maxPageNumber, statistics };
            }

            const existingStats = state.userStatistics.statistics || [];
            return {
                maxPageNumber,
                statistics: [...existingStats, ...statistics],
            };
        } catch (error) {
            handleError(error.message);
            return rejectWithValue(error.message);
        }
    },
);

export const fetchUserBalanceHistory = createAsyncThunk(
    'userStatistics/fetchUserBalanceHistory',
    async ({ page, userId }, { dispatch, rejectWithValue, getState }) => {
        try {
            const state = getState();
            const perPage = selectPerPage(state);

            const payload = await API.user.getBalanceHistory(userId, page, perPage);
            payload.balanceHistory = mapBalanceUpdateCodeToDescription(payload.balanceHistory);

            if (payload.balanceHistory.length) {
                dispatch(toggleModal({ isOpen: true, modal: 'vacationStatistic' }));
            } else {
                notification.info({
                    message: 'This employee balance history has no records yet',
                });
            }

            return {
                ...payload,
                page,
            };
        } catch (error) {
            return rejectWithValue(error.message);
        }
    },
);
